import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { ActiveInactiveFor, KeyValues10, KeyValues15, KeyValues3, KeyValues5, LocalService, Paging, ProductEntryType, PurchaseEntryDetailsInitialization, PurchaseEntryInitialization, StatusKeyValues15, StatusKeyValues20, StatusWithId, SupplierWrapper, UpadatePurchaseEntryDetailFor, Wrappers15, Wrappers20 } from './local.service';
import { HttpRequestComponent } from '../app/shared/http-request/http-request.component';

@Injectable({
  providedIn: 'root'
})
export class PurchaseEntryService {
  private controllerName = service_controllers_methods.purchaseEntry.controller;
  private methods = service_controllers_methods.purchaseEntry.methods;

  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  public getPurchaseEntryInitialization(businessId: string, strId: string): Observable<PurchaseEntryInitialization> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: strId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPurchaseEntryInitialization, body);
  }

  public getPurchaseEntry(strId: string, languageCode?: string): Observable<SupplierWrapper> {
    let body = {
      sel: this.localService.getSelected(languageCode),
      strId: strId
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPurchaseEntry, body);
  }

  public savePurchaseEntry(wrapper: KeyValues15, isSkipSupplier: boolean): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      wrapper: wrapper,
      isSkipSupplier: isSkipSupplier
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SavePurchaseEntry, body);
  }

  public getPurchaseEntries(businessId: string, purchaseEntryType: number, paging?: Paging, isActive: boolean = true): Observable<Wrappers15> {
    let body = {
      sel: this.localService.getSelected(),
      pag: paging,
      dt: { v1: businessId, v2: isActive ? '1' : '0', v3: purchaseEntryType.toString() } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPurchaseEntries, body);
  }

  public activeInactiveStatus(strId: string, actionFor: ActiveInactiveFor): Observable<StatusWithId> {
    let body = {
      strId: strId,
      sel: this.localService.getSelected(),
      iActionFor: parseInt(actionFor.toString())
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ActiveInactiveStatus, body);
  }

  public getNextPurchaseEntryReference(businessId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetNextPurchaseEntryReference, body);
  }

  public getPurchaseEntryDetailsInitialization(businessId: string, strId: string): Observable<PurchaseEntryDetailsInitialization> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: strId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPurchaseEntryDetailsInitialization, body);
  }

  public getPurchaseEntryDetails(businessId: string, purchaseEntryId: string, paging?: Paging, isActive: boolean = true): Observable<Wrappers20> {
    let body = {
      sel: this.localService.getSelected(),
      pag: paging,
      dt: { v1: businessId, v2: isActive ? '1' : '0', v3: purchaseEntryId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPurchaseEntryDetails, body);
  }

  public getSearchedProducts(businessId: string, searchKey?: string, productEntryType: ProductEntryType = ProductEntryType.Billing): Observable<KeyValues10[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: searchKey, v4: productEntryType.toString() } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSearchedProducts, body, false);
  }

  public savePurchaseEntryDetail(purchaseEntryId: string, businessId: string, data: KeyValues15, selectedPriceOption: string, purchaseEntryType: number, isMaintainStatus: boolean): Observable<StatusKeyValues20> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: purchaseEntryId, v2: businessId, v3: selectedPriceOption, v4: purchaseEntryType.toString(), v5: isMaintainStatus ? '1' : '0' } as KeyValues5,
      data: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SavePurchaseEntryDetail, body);
  }

  public updatePurchaseEntryDetail(purchaseEntryDetailId: string, actionFor: UpadatePurchaseEntryDetailFor, strValue: string, purchaseEntryType: number, isMaintainStatus: boolean): Observable<StatusKeyValues20> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: purchaseEntryDetailId, v2: strValue, v4: purchaseEntryType.toString(), v5: isMaintainStatus ? '1' : '0' } as KeyValues5,
      iActionFor: actionFor
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.UpdatePurchaseEntryDetail, body);
  }

  public getPurchaseEntryHistories(purchaseEntryDetailId: string): Observable<KeyValues5[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: purchaseEntryDetailId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPurchaseEntryHistories, body);
  }
}
